import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f7b1156"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center flex-1 modal-header-title" }, "添加产康包", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-colum" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (v, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex-row flex-align-center ck-item",
                onClick: ($event: any) => (_ctx.select(v))
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((v.selected) = $event),
                  class: "mr-2"
                }, null, 8, _hoisted_9), [
                  [_vModelCheckbox, v.selected]
                ]),
                _createElementVNode("div", null, _toDisplayString(v.title) + " - " + _toDisplayString(v.remark || "无备注"), 1)
              ], 8, _hoisted_8))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}